<template>
    <div>
        <b-modal id="wishList-modal" hide-footer hide-header style="max-width: 500px !important;top: 100px;">
            <b-tabs content-class="mt-3">
                <b-tab title="auf Merkliste setzen" active>
                    <add-to-wish-list :wishListEan="wishListEan"></add-to-wish-list>
                </b-tab>
                <b-tab title="neue Merkliste anlegen">
                    <create-wish-list  :modalName="modalName" :wishListEan="wishListEan" :Action="WishListAction"></create-wish-list>
                </b-tab>
            </b-tabs>
        </b-modal>
    </div>
</template>
<script>
    import AddToWishList from './AddToWishList.vue';
    import CreateWishList from './CreateWishList.vue';
    export default {
        props: ['wishListEan','WishListGuid','WishListAction'],
        data() {
            return {
                modalName:"wishList-modal"
            }
        },
        methods: {
        },
        components: {
            AddToWishList,
            CreateWishList
        },
    }
</script>